import axios from "axios";

export default {
  state: {
    requests: [],
    responses: [],
  },

  getters: {
    getRequests(state) {
      return state.requests;

    },

    getResponses(state) {
      return state.responses;
    },
  },

  mutations: {
    addRequest(state, request) {
      state.requests.push(request);
    },

    addResponse(state, response) {
      state.responses.push(response);
    },
  },

  actions: {
    addRequest({ commit, dispatch }, request) {
      commit("addRequest", request);
      dispatch("saveLogsToServer");
    },

    addResponse({ commit, dispatch }, response) {
      commit("addResponse", response);
      dispatch("saveLogsToServer");
    },

    saveLogsToServer({ state }) {
      const logsData = {
        requests: state.requests,
        responses: state.responses,
      };
      console.log(logsData);
      axios.post("/api/logs", logsData)
        .then(() => {
          console.log("Log salvdo com sucesso!");
        })
        .catch((error) => {
          console.error("Error ao salvar log:", error);
        });
    },
  },
};
